import { Navigate, useLocation, useParams } from 'react-router'
import { ApplicationRoutes } from '~/types/RoutingTypes'

/**
 * Sends legacy `/schedules/:id?` URLs (deep links, bookmarks) to the admin
 * panel so its role guard applies; keeps the id, query and hash.
 */
export const SchedulesRedirect = () => {
  const { id } = useParams<{ id?: string }>()
  const { search, hash } = useLocation()
  const pathname = id
    ? `${ApplicationRoutes.SCHEDULES}/${encodeURIComponent(id)}`
    : ApplicationRoutes.SCHEDULES

  return <Navigate to={{ pathname, search, hash }} replace />
}
